import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createWatchlistEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackWatchlistOpen = (
    source: PosthogTrackingSource,
    watchlistId?: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.WATCHLIST_OPEN,
      properties: {
        source,
        ...(watchlistId !== undefined && { watchlistId }),
      },
    });

  const trackWatchlistCreate = (
    source: PosthogTrackingSource,
    watchlistId?: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.WATCHLIST_CREATE,
      properties: {
        source,
        ...(watchlistId !== undefined && { watchlistId }),
      },
    });

  const trackWatchlistTabSelected = (
    source: PosthogTrackingSource,
    type: string,
    watchlistId?: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.WATCHLIST_TAB_SELECTED,
      properties: {
        source,
        type,
        ...(watchlistId !== undefined && { watchlistId }),
      },
    });

  return {
    trackWatchlistOpen,
    trackWatchlistCreate,
    trackWatchlistTabSelected,
  };
};
